/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Support_TitleInputs */

const en_support_title = /** @type {(inputs: Support_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support`)
};

const id_support_title = /** @type {(inputs: Support_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bantuan`)
};

/**
* | output |
* | --- |
* | "Support" |
*
* @param {Support_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const support_title = /** @type {((inputs?: Support_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Support_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_support_title(inputs)
	return en_support_title(inputs)
});